export default __webpack_public_path__ + "static/media/vitalik_profile.f95ef056.jpeg";